import { baseApi, AUTH_TAG } from '@/shared';

import type { TLoginRequest, TLoginResponse } from './types';

export const authApi = baseApi.injectEndpoints({
  endpoints: build => ({
    login: build.mutation<TLoginResponse, TLoginRequest>({
      query: (data: TLoginRequest) => ({
        url: '/auth/login',
        method: 'POST',
        body: {
          login: data.login,
          password: data.password,
        },
      }),
      invalidatesTags: (result) => {
        return result ? [AUTH_TAG] : [];
      },
    }),
  }),
});

export const { useLoginMutation } = authApi;
